import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeSquareBrackets'
})
export class RemoveSquareBracketsPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    return value.replace(/[\[\]]/g, '');
  }

}
